// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectPlan  {
    _originalTypeClassName = "Loom.BO.ProjectPlan";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectPlan.translate = translateService;
}
this.PlanPerProjectCosts = [];
this.Id = null;
this.ModifiedOn = null;
this.Name = null;
this.Description = null;
this.IsActive = false;
this.StartDate = null;
this.EndDate = null;
this.WorkableDays = null;
this.PrePeriodTSDeclaredEffort = null;
this.PrePeriodTSDeclaredCost = null;
this.PrePeriodTargetEffort = null;
this.PrePeriodTargetCost = null;
this.PrePeriodEffortUtilization = null;
this.PrePeriodCostUtilization = null;
this.PostPeriodTotalEffort = null;
this.PostPeriodTotalCost = null;
this.PostPeriodTargetEffort = null;
this.PostPeriodTargetCost = null;
this.PostPeriodEffortUtilization = null;
this.PostPeriodCostUtilization = null;
this.PeriodEffortInDays = null;
this.PeriodTotalCost = null;
this.PeriodEffortInPMs = null;
this.PeriodTargetCost = null;
this.TotalTargetEffortInPMs = null;
this.TotalTargetCost = null;
this.PlanPeriodEffortUtilization = null;
this.PlanPeriodCostUtilization = null;
this.TotalGAEffortInPMs = null;
this.TotalGAPersonnelCosts = null;
this.TotalGAEffortUtilization = null;
this.TotalGACostUtilization = null;
this.DurationInMonths = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ModifiedOn:any;
Name:any;
Description:any;
IsActive:any;
StartDate:any;
EndDate:any;
WorkableDays:any;
PrePeriodTSDeclaredEffort:any;
PrePeriodTSDeclaredCost:any;
PrePeriodTargetEffort:any;
PrePeriodTargetCost:any;
PrePeriodEffortUtilization:any;
PrePeriodCostUtilization:any;
PostPeriodTotalEffort:any;
PostPeriodTotalCost:any;
PostPeriodTargetEffort:any;
PostPeriodTargetCost:any;
PostPeriodEffortUtilization:any;
PostPeriodCostUtilization:any;
PeriodEffortInDays:any;
PeriodTotalCost:any;
PeriodEffortInPMs:any;
PeriodTargetCost:any;
TotalTargetEffortInPMs:any;
TotalTargetCost:any;
PlanPeriodEffortUtilization:any;
PlanPeriodCostUtilization:any;
TotalGAEffortInPMs:any;
TotalGAPersonnelCosts:any;
TotalGAEffortUtilization:any;
TotalGACostUtilization:any;
DurationInMonths:any;
Organisation:any;
ModifiedBy:any;
PlanPerProjectCosts:any;
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
if (oldValue != null) {
Domain.Organisation.removeProjectPlans(oldValue, $this);
}
Domain.Organisation.addProjectPlans(value, $this);
}
}
static setModifiedBy = ($this, value) => {
var oldValue = $this.ModifiedBy;
$this.ModifiedBy = value;
if (value != null) {
}
}
static setPlanPerProjectCosts = ($this, items) => {
                if (items == null) items = [];
                if ($this.PlanPerProjectCosts == null) $this.PlanPerProjectCosts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PlanPerProjectCosts.length > 0) {
                    Domain.ProjectPlan.removePlanPerProjectCosts($this, $this.PlanPerProjectCosts[0]);
                }

                Domain.ProjectPlan.addManyPlanPerProjectCosts($this, copyItems);
            }
static addManyPlanPerProjectCosts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectPlan.addPlanPerProjectCosts($this, items[i]);
                }
            }
static addPlanPerProjectCosts = ($this, item) => {
                if ($this.PlanPerProjectCosts == null) $this.PlanPerProjectCosts = [];
                if (item == null || $this.PlanPerProjectCosts.indexOf(item) > -1) return;
                $this.PlanPerProjectCosts.push(item);
if (item.Plan != $this) {
Domain.PlanPerProjectCostSummary.setPlan(item, $this);
}
}
static addRangePlanPerProjectCosts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectPlan.addPlanPerProjectCosts($this, item));
            }
static removePlanPerProjectCosts = ($this, item) => {
                if ($this == null || $this.PlanPerProjectCosts == null || $this.PlanPerProjectCosts.indexOf(item) === -1) return;
                var _index = $this.PlanPerProjectCosts.indexOf(item);
                $this.PlanPerProjectCosts.splice(_index, 1);
item.Plan = null;
}
static clearPlanPerProjectCosts = ($this) => { $this.PlanPerProjectCosts = null; }

static CalculateAllCosts($this: any): any{$this.StartDate = new Date(new Date(moment([moment($this?.StartDate).year(), ((moment($this?.StartDate).month() + 1)) - 1, 1]).toDate())?.setHours(0, 0, 0, 0));
$this.EndDate = new Date(new Date(moment([moment($this?.EndDate).year(), ((moment($this?.EndDate).month() + 1)) - 1, 1]).toDate())?.setHours(0, 0, 0, 0));
$this.EndDate = new Date(new Date((moment((moment($this?.EndDate).add(1, "M")).toDate()).add(-1, "d")).toDate())?.setHours(0, 0, 0, 0));
if (((new Date($this?.StartDate).getTime()) > (new Date($this?.EndDate).getTime()))) {throw Error("The end date cannot be before the start date!");}
Domain.ProjectPlan.CalculateAllProjectSummaries($this);
}
static CalculateAllProjectSummaries($this: any): any{let watch = new System.Diagnostics.Stopwatch();
watch.restart();
for (let _isummary = 0; _isummary < ($this?.PlanPerProjectCosts == null ? 0 : $this?.PlanPerProjectCosts.length); _isummary++) {let summary = $this?.PlanPerProjectCosts[_isummary];Domain.PlanPerProjectCostSummary.CalculateCosts(summary);}
Domain.ProjectPlan.CalculatePlanTotals($this);
console.info("Calculating Project Summaries took: " + watch.elapsed);
}
static CalculateCostsForSingleEmployee($this: any, resource: any): any{Domain.PlanPerProjectCostSummary.CalculateCosts(resource?.PlanPerProjectCostSummary);
Domain.ProjectPlan.CalculatePlanTotals($this);
}
static CalculatePlanTotals($this: any): any{$this.PeriodEffortInDays = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.PeriodEffortInDays);
$this.PeriodEffortInPMs = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.PeriodEffortInPMs);
$this.PeriodTotalCost = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.PeriodTotalCost);
$this.PeriodTargetCost = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.GAPersonnelCosts);
$this.TotalGAEffortInPMs = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.GAEffortInPMs);
$this.TotalTargetEffortInPMs = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.PeriodTargetEffortInPMs);
$this.PostPeriodTotalEffort = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.PostPeriodTotalEffort);
$this.PostPeriodTotalCost = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.PostPeriodTotalCost);
$this.PostPeriodTargetEffort = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.PostPeriodTargetEffort);
$this.PostPeriodTargetCost = $this?.PlanPerProjectCosts?.linq?.sum((a) => a?.PostPeriodTargetCost);
}
static GetDurationInMonths($this: any): any{return Domain.Util.GetDateRangeDurationInMonths($this?.StartDate, $this?.EndDate);
}
static GetPlanPeriodCostUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.TotalTargetCost, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PeriodTotalCost) / Joove.Common.safeNumber($this?.TotalTargetCost), 2);
}
static GetPlanPeriodEffortUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.TotalTargetEffortInPMs, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PeriodEffortInPMs) / Joove.Common.safeNumber($this?.TotalTargetEffortInPMs), 2);
}
static GetPostPeriodCostUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PostPeriodTargetCost, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PostPeriodTotalCost) / Joove.Common.safeNumber($this?.PostPeriodTargetCost), 2);
}
static GetPostPeriodEffortUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PostPeriodTargetEffort, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PostPeriodTotalEffort) / Joove.Common.safeNumber($this?.PostPeriodTargetEffort), 2);
}
static GetPrePeriodCostUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PrePeriodTargetCost, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PrePeriodTSDeclaredCost) / Joove.Common.safeNumber($this?.PrePeriodTargetCost), 2);
}
static GetPrePeriodEffortUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PrePeriodTargetEffort, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PrePeriodTSDeclaredEffort) / Joove.Common.safeNumber($this?.PrePeriodTargetEffort), 2);
}
static GetTotalGACostUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.TotalGAPersonnelCosts, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PostPeriodTotalCost) / Joove.Common.safeNumber($this?.TotalGAPersonnelCosts), 2);
}
static GetTotalGAEffortUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.TotalGAEffortInPMs, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PostPeriodTotalEffort) / Joove.Common.safeNumber($this?.TotalGAEffortInPMs), 2);
}
static Reset($this: any): any{$this?.PlanPerProjectCosts?.splice(0, $this?.PlanPerProjectCosts.length);
Domain.ProjectPlan.CalculateAllCosts($this);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}